import unescape from 'lodash/unescape';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/icon/Icon';
import DestinationSchema from 'destination/DestinationSchema';

const SearchAirportHero = ({
    destination,
    city,
    isMobile
}) => {
    const subtitle = (!isMobile)
        ? 'Make flying easy with the smarter way to park and travel.'
        : 'Save Money. Save Time. Easy Checkout.';

    return (
        <div className="SearchAirportHero">
            <div className="SearchAirportHero-content">
                <div
                    className="SearchAirport-container"
                    itemScope
                    itemType="http://schema.org/Place"
                >
                    <h1 className="SearchAirportHero-title">
                        {unescape(destination.title)} Parking
                        <meta
                            itemProp="name"
                            content={unescape(destination.title)}
                        />
                    </h1>
                    <DestinationSchema
                        destination={destination}
                        city={city}
                    />
                    <span className="SearchAirportHero-subtitle">{subtitle}</span>
                    <span className="SearchAirportHero-tagline">
                        <Icon name="check-circle" /> Plans change? Cancel up to your start time for a full refund.
                    </span>
                </div>
                {!isMobile &&
                    <div className="SearchAirportHero-value-props">
                        <div className="SearchAirportHero-value-prop">
                            <span className="SearchAirportHero-icon SearchAirportHero-icon-pricing" />
                            <h3>
                                Compare Daily Pricing
                                <small>and get a great deal</small>
                            </h3>
                        </div>
                        <div className="SearchAirportHero-value-prop">
                            <span className="SearchAirportHero-icon SearchAirportHero-icon-times" />
                            <h3>
                                Check Shuttle Times
                                <small>so you can get to the terminal on time</small>
                            </h3>
                        </div>
                        <div className="SearchAirportHero-value-prop">
                            <span className="SearchAirportHero-icon SearchAirportHero-icon-ratings" />
                            <h3>
                                See Ratings
                                <small>from other drivers and park confidently</small>
                            </h3>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

SearchAirportHero.propTypes = {
    destination: PropTypes.object.isRequired,
    city: PropTypes.object.isRequired,
    isMobile: PropTypes.bool
};

export default SearchAirportHero;
